import React from "react";

type IconProps = React.HTMLAttributes<HTMLDivElement>;

export const UserOffCircleIcon = (props: IconProps) => {
  return (
    <div
      style={{
        width: 60,
        height: 60,
        borderRadius: "50%",
        backgroundColor: "#E9EFF4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.33333 3.0404C8.0505 1.92929 9.30303 1.20202 10.7172 1.20202C12.9495 1.20202 14.7576 3.0101 14.7576 5.24242C14.7576 6.65657 14.0303 7.90909 12.9192 8.62626L7.33333 3.0404ZM18.798 14.5051C18.7778 13.3939 18.1616 12.3737 17.1717 11.8586C16.6263 11.5758 16.0303 11.3131 15.3838 11.0909L18.798 14.5051ZM20 18.5657L1.43434 0L0 1.42424L8.9798 10.404C7.15151 10.6364 5.55556 11.202 4.26263 11.8687C3.25253 12.3838 2.63636 13.4242 2.63636 14.5556V17.3636H15.9394L18.5758 20L20 18.5657Z"
          fill="#22638D"
        />
      </svg>
    </div>
  );
};